import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/actions/supplierstate.action';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import * as ProfileSelectors from '../../store/selectors/supplierstate.selector';
import * as MasterDataSelectors from "../../store/selectors/masterdata.selector";
import * as MasterDataActions from "../../store/actions/masterdata.action";
import { UserDetails } from 'app/profile/models/user.model';
import { OnboardingState } from 'app/profile/store/state/onboarding.state';
import { SupplierTaskService } from 'app/profile/services/supplier-task.service';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { OTPService } from 'app/shared/services/otp/otp.service';
@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  supplierCode: string;
  supplierName: string;
  supplierEmail: string;
  userDetails: UserDetails;
  portalTaskId: number;
  taskDetail: SupplierTaskDetail;

  constructor(private route: ActivatedRoute,
    private supplierStore: Store<SupplierState>,
    private onboardingStore: Store<OnboardingState>,
    private taskService: SupplierTaskService,
    private router: Router,
    private translate: I18nService,
    private otpService: OTPService
  ) { }

  ngOnInit(): void {
    // Based on url params get portal task Id
    // with portal task Id get task metadata
    // based on metadata decide which component to load and basic config
    this.supplierCode = this.route.snapshot.params['code'];
    this.portalTaskId = this.route.snapshot.params['portalTaskId'];

    //  Distpatch action to load currect user
    this.supplierStore.dispatch(new GetSupplierProfileCurrentUser());
    this.onboardingStore.dispatch(new MasterDataActions.GetContextVerbiage());

    this.supplierStore.select(ProfileSelectors.SelectCurrentUser).subscribe(userDetails => {
      if (userDetails) {
        this.userDetails = userDetails;
        this.supplierEmail = userDetails.supplierContact.emailId;

        //  Find supplier data for the current supplier code
        let supplierMap = userDetails.supplierContact.supplierMaps.find(map => map.supplierCode == this.supplierCode);
        if (supplierMap) {
          this.supplierName = supplierMap.supplierName;
        }
      }
    });

    this.taskService.getSupplierTasks(this.supplierCode, this.portalTaskId).subscribe(tasks => {
      if (tasks && tasks.length > 0) {
        const selectedTask = tasks[0];
        if (selectedTask.isSecure && !this.otpService.isAuthenticated()) {
          this.otpService.requestAuthentication(this.router.url);
        }
        this.navigateToTask(selectedTask);
        this.taskDetail = selectedTask
      }
    });
  }

  navigateToTask(taskInfo: SupplierTaskDetail) {
    if (taskInfo.isProfileTask) {
      this.router.navigate([`${this.supplierCode}`, "Task", `${taskInfo.portalTaskID}`, `${taskInfo.subTaskType}`]);
    } else {
      this.router.navigate([`${this.supplierCode}`, "Onboarding", "Home"]);
    }
  }
}
